import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory'
import { decodeGlobalId, getTypename } from '~/utils/id'

/**
 * IntrospectionFragmentMatcher enables Apollo Cache to match the
 * correct fragment to the corresponding union type.
 *
 * https://www.apollographql.com/docs/react/advanced/fragments.html#fragment-matcher
 */
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [
        {
          kind: 'UNION',
          name: 'SearchResultItem',
          possibleTypes: [
            { name: 'EventResult' },
            { name: 'CityResult' },
            { name: 'LocationResult' },
            { name: 'ArtistResult' },
          ],
        },
        {
          kind: 'UNION',
          name: 'CheckoutRow',
          possibleTypes: [{ name: 'CheckoutTicketRow' }],
        },
        {
          kind: 'UNION',
          name: 'Event',
          possibleTypes: [
            { name: 'ActiveEvent' },
            { name: 'ExpiredEvent' },
            { name: 'CancelledEvent' },
          ],
        },
      ],
    },
  },
})

const dataIdFromObject = ({ id, __typename }) => {
  let typename = __typename
  let dbId = id

  if (typeof id === 'string') {
    try {
      typename = getTypename(id)
      dbId = decodeGlobalId(id)
    } catch {}
  }

  switch (__typename) {
    case 'EventResult':
    case 'CityResult':
    case 'LocationResult':
    case 'ArtistResult':
      return `${__typename}:${id}`
    default:
      return id ? `${typename}:${dbId}` : null
  }
}

export default function createApolloCache(initialState) {
  return new InMemoryCache({ fragmentMatcher, dataIdFromObject }).restore(
    initialState || {}
  )
}
